/**
 * Card colour-swatch interaction (Rieker / remonte).
 *
 *   Hover a swatch  -> preview that colour on the card, including the SECOND
 *                      (hover) image, so the colour shows even while the card
 *                      is in its CSS :hover state. (Fixes the "swatches won't
 *                      work when 'show second image on hover' is on" issue.)
 *   Leave the swatch-> revert to the locked colour, or the original default.
 *   Click a swatch  -> LOCK that colour on the card (no navigation) and
 *                      repoint the card's product links to that variant.
 *
 * Document-delegated + guarded so it binds exactly once and also covers cards
 * injected asynchronously (e.g. the PDP "You may also like" product-
 * recommendations, which is where this was reported). The capture-phase click
 * pre-empts the legacy per-card swatch handlers and the card click-through.
 */
(function () {
  if (window.__rkCardSwatch) return;
  window.__rkCardSwatch = true;

  var bad = function (u) { return !u || u === 'undefined' || u.indexOf('Liquid error') !== -1; };
  var cardOf = function (el) { return el && el.closest ? el.closest('.card-wrapper, .card') : null; };
  var imgsOf = function (c) { return c ? c.querySelectorAll('.media--hover-effect img, .card__media img') : []; };

  // Apply a colour image to every displayed image in the card (primary + hover).
  function apply(card, url) {
    if (!card || bad(url)) return;
    imgsOf(card).forEach(function (img) {
      if (!img.hasAttribute('data-rk-orig')) {
        img.setAttribute('data-rk-orig', (img.getAttribute('src') || '') + '||' + (img.getAttribute('srcset') || ''));
      }
      img.setAttribute('src', url);
      img.setAttribute('srcset', url);
    });
  }

  // Revert to the locked colour if one is set, else each image's original.
  function revert(card) {
    if (!card) return;
    var locked = card.getAttribute('data-rk-locked');
    if (locked && !bad(locked)) { apply(card, locked); return; }
    imgsOf(card).forEach(function (img) {
      var raw = img.getAttribute('data-rk-orig');
      if (raw === null) return;
      var i = raw.indexOf('||');
      var src = i >= 0 ? raw.slice(0, i) : raw;
      var srcset = i >= 0 ? raw.slice(i + 2) : '';
      if (src) img.setAttribute('src', src);
      if (srcset) { img.setAttribute('srcset', srcset); } else { img.removeAttribute('srcset'); }
    });
  }

  function lock(card, swatch) {
    if (!card) return;
    var url = swatch.dataset.imageUrl;
    apply(card, url);
    if (!bad(url)) card.setAttribute('data-rk-locked', url);
    card.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
    swatch.classList.add('active');
    var pUrl = swatch.dataset.productUrl, vId = swatch.dataset.variantId;
    if (pUrl && vId) {
      var href = pUrl + (pUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + vId;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = href; });
    }
  }

  // Warm the cache: the first time the pointer enters a card, prefetch that
  // card's swatch colour images (low priority) so the hover swap is instant
  // instead of waiting on a first-hover network fetch. Only cards the user
  // actually touches are prefetched.
  function prefetch(card) {
    if (!card || card.hasAttribute('data-rk-prefetched')) return;
    card.setAttribute('data-rk-prefetched', '1');
    card.querySelectorAll('.color-swatch:not(.disabled)').forEach(function (s) {
      var u = s.dataset.imageUrl;
      if (bad(u)) return;
      var im = new Image();
      try { im.fetchPriority = 'low'; } catch (e) {}
      im.src = u;
    });
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    prefetch(t.closest('.card-wrapper, .card'));
    var sw = t.closest('.color-swatch');
    if (!sw || sw.classList.contains('disabled') || sw.disabled) return;
    apply(cardOf(sw), sw.dataset.imageUrl);
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('.color-swatch') : null;
    if (!sw) return;
    // Dead-zone the inter-swatch gaps: while the pointer is still anywhere within the
    // same swatch row (another swatch, a wrapper, or the 4px flex gap — all inside
    // .color-swatches), hold the current preview. Only snap back to the locked/clicked
    // colour once the pointer actually leaves the row.
    var row = sw.closest('.color-swatches');
    if (e.relatedTarget && row && row.contains(e.relatedTarget)) return;
    revert(cardOf(sw));
  });

  // Capture phase: pre-empt the legacy swatch handlers + the card click-through.
  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('.color-swatch') : null;
    if (!sw) return;
    e.preventDefault();
    if (sw.classList.contains('disabled') || sw.disabled) return;
    e.stopPropagation();
    lock(cardOf(sw), sw);
  }, true);
})();
